import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateGmailDisplayName = mutatorAction('updateGmailDisplayName', function (displayName) {
    var store = connectedAccountsStore();
    store.connectGmailState.displayName = displayName;
});
//# sourceMappingURL=updateGmailDisplayName.js.map